import axios from 'axios';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

interface StateItem {
  id: number;
  state_name: string;
  state_code: string;
  allowed: boolean;
}

const StateList = () => {
  const [states, setStates] = useState<StateItem[]>([]);
  const navigate = useNavigate();

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    navigate('/login');
  };

  // Fetch states from the API
  const fetchStates = async () => {
    try {
      const response = await axios.get('https://api.trubetx.com/admin/getStatelist');
      if (response.data) {
        setStates(response.data.data);
      } else {
        toast.error('Failed to fetch states.');
      }
    } catch (error) {
      console.error('Error fetching states:', error);
      toast.error('Error fetching states.');
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  // Toggle "Allowed" status
  const toggleAllowed = async (state: StateItem) => {
    try {
      const updatedState = { ...state, allowed: !state.allowed };

      const response = await axios.post(
        `https://api.trubetx.com/admin/updateState/${state.id}`,
        updatedState
      );

      if (response.data.status) {
        toast.success('State updated successfully!');
        setStates((prev) =>
          prev.map((s) => (s.id === state.id ? { ...s, allowed: !s.allowed } : s))
        );
      } else {
        toast.error('Failed to update state.');
      }
    } catch (error) {
      console.error('Error updating state:', error);
      toast.error('Error updating state.');
    }
  };

  const [searchTerm, setSearchTerm] = useState<string>('');

  const filteredStates = states.filter(
    (country) =>
      country?.state_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      country?.state_code?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="ml-0 lg:ml-[256px] p-4">
      <h2 className="text-2xl font-semibold mb-4 text-black">State Management</h2>
      <hr className="p-5" />

       {/* 🔍 Search Input */}
       <div className="mb-4">
        <input
          type="text"
          placeholder="Search by country name or code"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full lg:w-1/3 px-4 py-2 border rounded text-black"
        />
      </div>

      {/* Display States */}
      <div>
        {filteredStates.length > 0 ? (
          <table className="table-auto w-full text-black text-center">
            <thead>
              <tr>
                <th className="border px-4 py-2">S.No.</th>
                <th className="border px-4 py-2">State Name</th>
                <th className="border px-4 py-2">State Code</th>
                <th className="border px-4 py-2">Allowed</th>
                {/* <th className="border px-4 py-2">Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {filteredStates.map((state, index) => (
                <tr key={state.id}>
                  <td className="border px-4 py-2">{index + 1}</td>
                  <td className="border px-4 py-2">{state.state_name}</td>
                  <td className="border px-4 py-2">{state.state_code}</td>
                  <td className="border px-4 py-2">
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={state.allowed}
                        onChange={() => toggleAllowed(state)}
                        className="sr-only peer"
                      />
                      <div
                        className={`w-11 h-6 rounded-full relative transition-all ${
                          state.allowed ? 'bg-green-500' : 'bg-red-500'
                        }`}
                      >
                        <div
                          className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-all ${
                            state.allowed ? 'translate-x-5' : ''
                          }`}
                        ></div>
                      </div>
                    </label>
                  </td>
                  {/* <td className="border px-4 py-2">
                    <button
                      onClick={() => toast.info(`Editing state: ${state.state_name}`)}
                      className="bg-yellow-500 hover:bg-yellow-600 text-black py-1 px-3 rounded"
                    >
                      Edit Name/Code
                    </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-black">No states available at the moment.</p>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default StateList;
